/**
 * Hotel Services Index
 * Otel servislerini tek noktadan dışa aktarmak için barrel export dosyası.
 */

import { hotelBasicService } from './basic';
import { hotelHomeService } from './home';
import { hotelSearchService } from './search';
import { hotelReservationService } from './reservation';
import { hotelAuthService } from './auth';
import { hotelLandingService } from './landing';
import { hotelAbroadService } from './abroad';


// Bireysel servis export'ları (tree-shaking ve selektif import için)
export { hotelBasicService };
export { hotelHomeService };
export { hotelSearchService };
export { hotelReservationService };
export { hotelAuthService };
export { hotelLandingService };
export { hotelAbroadService };

/**
 * Tüm otel servislerini tek bir nesne altında toplayıp export eder.
 * Bu sayede `hotelServices.home.getPopularHotels()` şeklinde kullanım sağlanır.
 */
export const hotelServices = {
  basic: hotelBasicService,
  home: hotelHomeService,
  search: hotelSearchService,
  reservation: hotelReservationService,
  auth: hotelAuthService,
  landing: hotelLandingService,
  abroad: hotelAbroadService,
};

export default hotelServices;


